<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-home" :label="!isSmallerScreen ? 'Geral' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <UserSettingsGeneral />
      </div>
    </vs-tab>
    <!-- <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Change Password' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Info' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-info />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-github" :label="!isSmallerScreen ? 'Social Links' : ''">
      <div class="tab-social-links md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-social-links />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? 'Connections' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-connections />
      </div>
    </vs-tab> -->
    <!-- <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notifications' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-notifications />
      </div>
    </vs-tab> -->
    <vs-tab icon-pack="feather" icon="icon-layers" :label="!isSmallerScreen ? 'Departamentos' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <Department/>
      </div>
    </vs-tab>
     <vs-tab icon-pack="feather" icon="icon-layers" :label="!isSmallerScreen ? 'Funções' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <Cargos/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-clock" :label="!isSmallerScreen ? 'Horas extras' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <HorasExtras/>
      </div>
    </vs-tab>
    <!-- <vs-tab  icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Permissões' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <Permissoes/>
      </div>
    </vs-tab> -->
  </vs-tabs>
</template>

<script>

import UserSettingsGeneral from "./UserSettingsGeneral.vue"
import Department from "./Department.vue"
import Cargos from "./Cargos.vue"
import Permissoes from "./Permissoes.vue"
import HorasExtras from "./HorasExtras.vue"
import { PermissionsMixin } from "../../../mixins/permissions"

export default {
  mixins:[PermissionsMixin],
  components: {
   UserSettingsGeneral,
    Department,
    Cargos,
    Permissoes,
    HorasExtras
  },
  data() {
    return {

    }
  },
  mounted(){
    this.verifyRoles()
  },
  computed: {
    isSmallerScreen() {
      this.verifyRoles()
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
